import React from "react";
import Routes from "./utils/Routes";

function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;
